import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of, shareReplay, Subject, take, tap } from 'rxjs';
import { ConnectionService } from '../../services/connection/connection.service';
import { DataRepositoryService } from '../../services/data-repository/data-repository.service';
import { TaskInfoService } from '../../services/task-info/task-info.service';
import { CommandType } from '../../entity/enums';

import { AppConstants } from '../../entity/constants';
import { HttpStatusCode } from '@angular/common/http';
import { UpdateManagerNoteCommand } from '../../entity/utility-interfaces';

@Injectable({
  providedIn: 'root'
})
export class UpdateManagerNotesService {
  notifyError: BehaviorSubject<string> = new BehaviorSubject('');
  notifyError$ = this.notifyError.asObservable();
  updateManagerNotesSuccess: Subject<any> = new Subject();
  updateManagerNoteData: UpdateManagerNoteCommand[] = [];
 
  constructor(
    private connectionService: ConnectionService,
    private dataRepositoryService: DataRepositoryService,
    private taskInfoService: TaskInfoService
  ) {}
 
  /**
   * Set error message
   */
  showError(error: string) {
    this.notifyError.next(error);
  }
 
  /**
   * Create update payload object for manager note
   */
  formManagerNoteObject(task: any) {
    this.updateManagerNoteData = [
      {
        manager_note: task.manager_instruction,
        command_type: CommandType.UpdateManagerCommand,
        id:  crypto.randomUUID(),
        task_id: task?.task_id ?? '',
        timestamp: new Date(),
        user_id: this.dataRepositoryService.loggedInUser?.username ?? '',
        bl_id: task?.business_location_id ?? ''
      }
    ];
  }
 
  /**
   * Submit the update payload to backend
   */
  submitManagerNote(): Observable<any> {
    const submitStatus = new Subject<any>();
    let isSuccess = false;

    this.connectionService.httpReq({
      reqType: AppConstants.POSTREQUEST,
      endUrl: AppConstants.Command,
      directoryType: AppConstants.DP,
      data: this.updateManagerNoteData
    }).subscribe({
      next: () => {
        this.updateManagerNotesSuccess.next(true);
        isSuccess = true;
      },
      error: (error) => {
        if (error.status === HttpStatusCode.Forbidden) {
          this.updateManagerNotesSuccess.next(error);
        } else {
          this.updateManagerNotesSuccess.next(false);
        }
      },
      complete: () => {
        submitStatus.next(isSuccess);
        submitStatus.complete();
      }
    });
 
    return submitStatus.asObservable();
  }

}
